/**
 * The customer CSS of a page's parent folders, then its projects, one block per line.
 * Rows without CSS (custom_css null) are skipped: joined as "null" they broke the
 * next block's first selector in the editor.
 * With the page's item path ("f13.f90.pr24.pg120") the rows follow it, root first, like the
 * reader (fetchMagazineNew sorts the chain by depth): a root folder's @import leads, and a
 * moved folder stays below its new parent whatever the ids (spec 2026-09-30-evz-paket-4 §5.4).
 */
export default function joinCustomCss(folders, projects, itemPath) {
  const rows = [
    ...folders.map((row) => ({ key: `f${row.folder_id}`, css: row.custom_css })),
    ...projects.map((row) => ({ key: `pr${row.project_id}`, css: row.custom_css })),
  ];
  if (itemPath) {
    const order = itemPath.split('.');
    const rank = (row) => (order.indexOf(row.key) === -1 ? order.length : order.indexOf(row.key));
    rows.sort((a, b) => rank(a) - rank(b));
  }
  return rows
    .map((row) => row.css)
    .filter(Boolean)
    .map((css) => `${css}\n`)
    .join('');
}
